"use strict";
/**
 * VADE VE GÜN SINIRI — TEK YÜKLEM (madde 296, 30.09.2026 — ürün sahibi kararı;
 * Kapsam §14 VG-1 · VG-2).
 *
 * ════════════════════════════════════════════════════════════════════════
 * KURAL: VADE GÜNÜ SON GÜNDÜR — GECİKME ERTESİ GÜN BAŞLAR
 * ════════════════════════════════════════════════════════════════════════
 *
 * Vadesi bugün olan kalem gecikmiş DEĞİLDİR; yarın gecikmiş olur. *"Gecikmiş
 * mi"* sorusunu soran her yer (yasal uygunluk takvimi · görev listesi ·
 * İşlerim · Genel bakış gecikmiş özeti · görevin kapanış damgası) bu dosyadaki
 * yüklemi çağırır; ekran ya da servis başına ayrı karşılaştırma YAZILMAZ.
 *
 * ⚠️ **BU DOSYA BİR ARIZANIN CEVABIDIR.** Aynı görev vade gününde iki yüzeyde
 * iki farklı cevap veriyordu: yükümlülük takvimi vade ile *şimdi* arasındaki
 * farkı ZAMAN DAMGASINDAN sayıyordu (vade gününün 03:00'ünden itibaren eksi →
 * *gecikmiş*), görev listesi GÜN BAŞINI karşılaştırıyordu (*gecikmemiş*).
 *
 * ⚠️ **GÜN SINIRI YEREL SAATTİR, SUNUCU UTC'Sİ DEĞİL.** Türkiye'de gece
 * 00:00–03:00 arasında UTC günü hâlâ DÜNDÜR; "bugün"ü UTC'den okuyan kod o üç
 * saatte dünün gününü yaşar (gecikmeyi üç saat geç yakar, takvimi bir gün geri
 * gösterir). "Bugün" `yerelGun`dan okunur — bildirim taramasının, zamanlanmış
 * işlerin ve çıktı antetinin zaten kullandığı saha günü (`Europe/Istanbul`).
 * Tenant/işyeri başına saat dilimi alanı YOKTUR; açılırsa tek değişecek yer
 * burasıdır.
 *
 * ⚠️ **İKİ AYRI DEĞER, İKİ AYRI OKUYUCU — KARIŞTIRMA:**
 *   · AN (zaman damgası — *şimdi*)      → `yerelGun`     (saat dilimine ÇEVRİLİR)
 *   · GÜN (`@db.Date` — vade, termin)   → `takvimGunu`   (saat dilimine ÇEVRİLMEZ)
 * Gün hassasiyetli bir değeri saat dilimine çevirmek onu bir gün kaydırır
 * (`tarihGoster` ailesinin sunucu tarafı — G11).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.sahaGunuYanitiSchema = exports.YEREL_SAAT_DILIMI = void 0;
exports.yerelGun = yerelGun;
exports.takvimGunu = takvimGunu;
exports.yerelGunBasi = yerelGunBasi;
exports.vadeyeKalanGun = vadeyeKalanGun;
exports.vadeGectiMi = vadeGectiMi;
exports.vadeBugunMu = vadeBugunMu;
exports.vadeTarihiGectiMi = vadeTarihiGectiMi;
exports.vadeTarihineKalanGun = vadeTarihineKalanGun;
/** Saha gününün saat dilimi — tek sabit (ikinci kez yazılmaz). */
const zod_1 = require("zod");
exports.YEREL_SAAT_DILIMI = 'Europe/Istanbul';
const GUN_BICIMI = new Intl.DateTimeFormat('en-CA', {
    timeZone: exports.YEREL_SAAT_DILIMI,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
});
const GUN_MS = 86_400_000;
/** Bir ANIN yerel günü (`YYYY-AA-GG`) — "bugün"ün TEK kaynağı. */
function yerelGun(an = new Date()) {
    return GUN_BICIMI.format(an);
}
/**
 * GÜN hassasiyetli bir değerin (`@db.Date` — Prisma UTC gece yarısı döndürür)
 * takvim günü. ⚠️ Saat dilimine ÇEVRİLMEZ; bir AN için `yerelGun` kullanılır.
 */
function takvimGunu(gun) {
    return gun.toISOString().slice(0, 10);
}
/**
 * Yerel günün `@db.Date` karşılaştırma değeri (UTC gece yarısı). Sorgu
 * süzgeçleri bunu kullanır: `vadeTarihi < yerelGunBasi(simdi)` = *gecikmiş*.
 */
function yerelGunBasi(an = new Date()) {
    return new Date(`${yerelGun(an)}T00:00:00.000Z`);
}
/** Vadeye kalan TAM gün: vade bugünse 0, dünse −1, yarınsa 1. */
function vadeyeKalanGun(vadeGunu, bugun) {
    return Math.round((Date.parse(`${vadeGunu}T00:00:00Z`) - Date.parse(`${bugun}T00:00:00Z`)) / GUN_MS);
}
/**
 * **GECİKMİŞ Mİ — TEK YÜKLEM.** Vade günü son gündür; gecikme ertesi gün
 * başlar. İki girdi de `YYYY-AA-GG`dir: vade `takvimGunu`ndan, bugün
 * `yerelGun`dan.
 */
function vadeGectiMi(vadeGunu, bugun) {
    return vadeGunu < bugun;
}
/** Vade BUGÜN mü — *"bugün son gün"* (gecikmiş değil, son gün). */
function vadeBugunMu(vadeGunu, bugun) {
    return vadeGunu === bugun;
}
/**
 * `Date` girdili sarmalayıcı — iki değeri DOĞRU okuyucudan geçirir: vade bir
 * GÜNdür (`@db.Date` → `takvimGunu`), `simdi` bir ANdır (→ `yerelGun`).
 * Sunucu servisleri bunu çağırır; ikisini elle dizgeye çevirip karşılaştırmak
 * yanlış okuyucuyu seçmenin yoludur.
 */
function vadeTarihiGectiMi(vade, simdi = new Date()) {
    return vadeGectiMi(takvimGunu(vade), yerelGun(simdi));
}
/** `Date` girdili sarmalayıcı — vadeye kalan tam gün (bugünse 0). */
function vadeTarihineKalanGun(vade, simdi = new Date()) {
    return vadeyeKalanGun(takvimGunu(vade), yerelGun(simdi));
}
/**
 * SAHA GÜNÜ YANITI (madde 302 — 08.10.2026; Teknoloji §8 *"tarih tek
 * kaynaktan, saha günü"*). `GET /api/saha-gunu` gövdesi: tarih alanlarının
 * varsayılan *"bugün"* değeri ve `max` sınırı tarayıcı gününden DEĞİL buradan
 * gelir (web `useSahaGunu` · `useVarsayilanGun`). Tek alan, `yerelGun()`.
 */
exports.sahaGunuYanitiSchema = zod_1.z.object({
    sahaGunu: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});
//# sourceMappingURL=vade.js.map